// extracted by mini-css-extract-plugin
export default {"cell-wrapper":"EeFa2","cellWrapper":"EeFa2","cell-wrapper_header":"qEpZc","cellWrapper_header":"qEpZc"};